import $ from 'jquery';

// don't allow anything that's not a number (including decimal
// points, etc)
$('input.integer-field').on('keypress', e => {
  // make sure special characters still get through.
  // firefox will pass them with a charCode of 0;
  // chrome won't pass them at all
  if (e.charCode !== 0) {
    if (String.fromCharCode(e.which).match(/\D/)) {
      e.preventDefault();
    }
  }
});
